import { Cell, Row } from '@dexma/ui-components';
import i18n from 'asset/translation';
import React, { FormEvent } from 'react';
import { useAlertToaster } from 'adapter/in/common/context/Alert';
import { StyledAnimationDiv } from 'adapter/in/common/style';
import { StyledHeading, StyledHomeGrid, StyledInputSearchBar } from 'adapter/in/common/components/Home/style';
import { StyledAlert } from 'adapter/in/advanced-analytics/components/StyledAlert/StyledAlert';
import styled from 'styled-components';

export type StyledAlertType = 'info' | 'outline' | 'basic' | 'warning' | 'success' | 'error';

type HomeProps = {
    addButtonProps: {
        displayAddButton: boolean;
        addButton: JSX.Element;
    };
    searchDataId: string;
    headingTitle: string;
    handleSearchChange: (event: FormEvent<HTMLInputElement>) => void;
    children: React.ReactNode;
};

const FlexCell = styled(Cell)`
    display: flex;
    justify-content: flex-end;
`;

const Home = (props: HomeProps) => {
    const { addButtonProps, headingTitle, handleSearchChange, searchDataId } = props;
    const { message: alertMessage, show: showAlert, type: alertType, style } = useAlertToaster();

    return (
        <>
            <StyledHomeGrid fluid data-testid='home-list' $showAlert={showAlert}>
                <StyledAnimationDiv $animationStyle={style}>
                    <StyledAlert description={alertMessage} type={alertType as StyledAlertType} showIcon />
                    <Row className='heading'>
                        <Cell>
                            <StyledHeading text={headingTitle} type='h1' />
                        </Cell>
                        <FlexCell xs={6}>
                            {addButtonProps.displayAddButton && addButtonProps.addButton}
                            <StyledInputSearchBar
                                dataId={searchDataId}
                                type='text'
                                placeholder={i18n.t('common.search')}
                                icon='search'
                                onChange={handleSearchChange}
                                data-testid='search-input'
                                isItToSearch
                                label={headingTitle}
                            />
                        </FlexCell>
                    </Row>
                    {props.children}
                </StyledAnimationDiv>
            </StyledHomeGrid>
        </>
    );
};

export default Home;
